var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06724 13.8077C6.8949 13.8077 7.60763 13.3078 7.92036 12.5942H4.21411C4.52684 13.3078 5.2396 13.8077 6.06724 13.8077Z",
    fill: "#111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2474 6.68403V5.79785C10.2474 3.91497 8.99583 2.31911 7.28105 1.79787V1.2135C7.28105 0.544377 6.73667 0 6.06754 0C5.39842 0 4.85404 0.544377 4.85404 1.2135V1.79787C3.13923 2.31911 1.8877 3.91495 1.8877 5.79785V6.68403C1.8877 8.33795 1.25727 9.90623 0.112564 11.1C0.000382084 11.217 -0.031142 11.3896 0.0324455 11.5387C0.096033 11.6877 0.242462 11.7845 0.404532 11.7845H11.7306C11.8926 11.7845 12.039 11.6877 12.1026 11.5387C12.1662 11.3896 12.1347 11.217 12.0225 11.1C10.8778 9.90623 10.2474 8.33792 10.2474 6.68403ZM6.47204 1.63764C6.33891 1.6248 6.204 1.618 6.06754 1.618C5.93109 1.618 5.79618 1.6248 5.66304 1.63764V1.2135C5.66304 0.990461 5.8445 0.809002 6.06754 0.809002C6.29059 0.809002 6.47204 0.990461 6.47204 1.2135V1.63764Z",
    fill: "#111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3259 5.79803C11.3259 6.02143 11.507 6.20253 11.7304 6.20253C11.9538 6.20253 12.1349 6.02143 12.1349 5.79803C12.1349 4.17733 11.5038 2.65363 10.3578 1.50763C10.1998 1.34968 9.94369 1.34966 9.78571 1.50763C9.62774 1.6656 9.62774 1.9217 9.78571 2.07967C10.7789 3.07288 11.3259 4.39342 11.3259 5.79803Z",
    fill: "#111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.404257 6.20252C0.627649 6.20252 0.808757 6.02141 0.808757 5.79802C0.808757 4.39343 1.35575 3.07289 2.34893 2.07968C2.50691 1.92171 2.50691 1.66561 2.34893 1.50764C2.19099 1.34967 1.93486 1.34967 1.77689 1.50764C0.630885 2.65364 -0.000244141 4.17732 -0.000244141 5.79802C-0.000244141 6.02141 0.180864 6.20252 0.404257 6.20252Z",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIco);
export default __webpack_public_path__ + "static/media/bellIco.de286dcc5be0324ea618f34f2c6fa555.svg";
export { ForwardRef as ReactComponent };